export default "__VITE_ASSET__U99PqjRb__"